export default __webpack_public_path__ + "static/media/Web-Development.7f24e1c1.jpeg";